import { IsObject } from '../../helpers';
import { OBSERVABLE_PRIVATE } from './privates';
import { HasFactoryWaterMark } from '../../classes/class-helpers/factory';
import { ConstructClassWithPrivateMembers } from '../../misc/helpers/ClassWithPrivateMembers';
import { NewObservableContext } from './context/implementation';
import { InitObservableHook } from './hook/init';
export function ConstructObservable(instance, create) {
    ConstructClassWithPrivateMembers(instance, OBSERVABLE_PRIVATE);
    const privates = instance[OBSERVABLE_PRIVATE];
    privates.observers = [];
    InitObservableHook(instance, privates, NewObservableContext, create);
}
export function IsObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(OBSERVABLE_PRIVATE);
}
export const IS_OBSERVABLE_CONSTRUCTOR = Symbol('is-observable-constructor');
export function IsObservableConstructor(value, direct) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_OBSERVABLE_CONSTRUCTOR, direct);
}
export const IS_OBSERVABLE_LIKE_CONSTRUCTOR = Symbol('is-observable-constructor');
export function IsObservableLikeConstructor(value, direct) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_OBSERVABLE_LIKE_CONSTRUCTOR, direct)
        && HasFactoryWaterMark(value, IS_OBSERVABLE_CONSTRUCTOR, false);
}
//# sourceMappingURL=constructor.js.map